<div class="message-container" *ngIf="errorMessage">
  <div class="message error">
    <span class="message">{{ errorMessage }}</span>
    <button class="close-btn rojo-error2" (click)="closeErrorAlert()">✖</button>
  </div>
</div>
<div class="message-container" *ngIf="successMessage">
  <div class="message success">
    <span class="message">{{ successMessage }}</span>
    <button class="close-btn verde-ok2" (click)="closeSuccessAlert()">✖</button>
  </div>
</div>